/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReleaseNoteRow,
    ReleaseNoteRowFromJSON,
    ReleaseNoteRowFromJSONTyped,
    ReleaseNoteRowToJSON,
} from './';

/**
 * リリースノート一覧
 * @export
 * @interface ReleaseNoteList
 */
export interface ReleaseNoteList {
    /**
     * 
     * @type {Array<ReleaseNoteRow>}
     * @memberof ReleaseNoteList
     */
    releaseNotes?: Array<ReleaseNoteRow>;
}

export function ReleaseNoteListFromJSON(json: any): ReleaseNoteList {
    return ReleaseNoteListFromJSONTyped(json, false);
}

export function ReleaseNoteListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseNoteList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseNotes': !exists(json, 'release_notes') ? undefined : ((json['release_notes'] as Array<any>).map(ReleaseNoteRowFromJSON)),
    };
}

export function ReleaseNoteListToJSON(value?: ReleaseNoteList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_notes': value.releaseNotes === undefined ? undefined : ((value.releaseNotes as Array<any>).map(ReleaseNoteRowToJSON)),
    };
}


